import React from 'react';


const InnerBanner = ({title,info, style}) => {
  return (
      <section className='innerBanner text-center' style={style}>
        <div className="container position-relative">
          <div className="col-lg-7 mx-auto ">
            <h1 className='title-xxl fw-bold text-white'>{title}</h1>
            <p className='inner_banner_p'>{info}</p>
          </div>
        </div>
      </section>

  );
};

export default InnerBanner;